import React from 'react';

import Landing from '../components/landing';

function IndexPage(): JSX.Element {
  return <Landing />;
}

IndexPage.displayName = 'IndexPage';

export default IndexPage;
